import { usePluginConfig } from "@tagadapay/plugin-sdk";
import type { PluginConfig } from "../types/plugin";
import { useMemo } from "react";
import defaultConfig from "../../config/default.config.json";

export function useConfig() {
  const { config, storeId, isValid, error } = usePluginConfig<PluginConfig>();

  const pluginConfig = useMemo(() => {
    if (
      Object.keys(config).some(
        (key) =>
          ![
            "configName",
            "branding",
            "variants",
            "prices",
            "orderBumpIdVylarasCare",
            "orderBumpIdExpeditedShipping",
            "defaultCurrency",
            "features",
            "googleApiKey",
            "routes",
          ].includes(key)
      )
    ) {
      console.log("config is invalid, using default config");
      return {
        ...defaultConfig,
        ...config,
      };
    }

    return config;
  }, [config]);

  return { pluginConfig, storeId };
}
